'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
	if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object' && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define("q", [], factory);else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["q"] = factory();else root["q"] = factory();
})(undefined, function () {
	return (/******/function (modules) {
			// webpackBootstrap
			/******/ // The module cache
			/******/var installedModules = {};
			/******/
			/******/ // The require function
			/******/function __webpack_require__(moduleId) {
				/******/
				/******/ // Check if module is in cache
				/******/if (installedModules[moduleId])
					/******/return installedModules[moduleId].exports;
				/******/
				/******/ // Create a new module (and put it into the cache)
				/******/var module = installedModules[moduleId] = {
					/******/exports: {},
					/******/id: moduleId,
					/******/loaded: false
					/******/ };
				/******/
				/******/ // Execute the module function
				/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
				/******/
				/******/ // Flag the module as loaded
				/******/module.loaded = true;
				/******/
				/******/ // Return the exports of the module
				/******/return module.exports;
				/******/
			}
			/******/
			/******/
			/******/ // expose the modules object (__webpack_modules__)
			/******/__webpack_require__.m = modules;
			/******/
			/******/ // expose the module cache
			/******/__webpack_require__.c = installedModules;
			/******/
			/******/ // __webpack_public_path__
			/******/__webpack_require__.p = "/build/";
			/******/
			/******/ // Load entry module and return exports
			/******/return __webpack_require__(0);
			/******/
		}(
		/************************************************************************/
		/******/[
		/* 0 */
		/***/function (module, exports, __webpack_require__) {

			"use strict";

			/**
    * @module q
    **/

			Object.defineProperty(exports, "__esModule", {
				value: true
			});
			var Q;

			/**
    * @class Q
    */
			function qFactory(exceptionHandler) {

				/**
     * @returns {Deferred} Returns a new instance of deferred.
     */
				var defer = function defer() {
					var pending = [],
					    value,
					    deferred;

					deferred = {

						resolve: function resolve(val) {
							if (pending) {
								var callbacks = pending;
								pending = undefined;
								value = ref(val);

								if (callbacks.length) {
									var callback;
									for (var i = 0, ii = callbacks.length; i < ii; i++) {
										callback = callbacks[i];
										value.then(callback[0], callback[1], callback[2]);
									}
								}
							}
						},

						reject: function reject(reason) {
							deferred.resolve(createInternalRejectedPromise(reason));
						},

						notify: function notify(progress) {
							if (pending) {
								var callbacks = pending;

								if (pending.length) {
									var callback;
									for (var i = 0, ii = callbacks.length; i < ii; i++) {
										callback = callbacks[i];
										callback[2](progress);
									}
								}
							}
						},

						promise: {
							then: function then(callback, errback, progressback) {
								var result = defer();

								var wrappedCallback = function wrappedCallback(value) {
									try {
										result.resolve((isFunction(callback) ? callback : defaultCallback)(value));
									} catch (e) {
										result.reject(e);
										exceptionHandler(e);
									}
								};

								var wrappedErrback = function wrappedErrback(reason) {
									try {
										result.resolve((isFunction(errback) ? errback : defaultErrback)(reason));
									} catch (e) {
										result.reject(e);
										exceptionHandler(e);
									}
								};

								var wrappedProgressback = function wrappedProgressback(progress) {
									try {
										result.notify((isFunction(progressback) ? progressback : defaultCallback)(progress));
									} catch (e) {
										exceptionHandler(e);
									}
								};

								if (pending) {
									pending.push([wrappedCallback, wrappedErrback, wrappedProgressback]);
								} else {
									value.then(wrappedCallback, wrappedErrback, wrappedProgressback);
								}

								return result.promise;
							},

							"catch": function _catch(callback) {
								return this.then(null, callback);
							},

							"finally": function _finally(callback) {

								function makePromise(value, resolved) {
									var result = defer();
									if (resolved) {
										result.resolve(value);
									} else {
										result.reject(value);
									}
									return result.promise;
								}

								function handleCallback(value, isResolved) {
									var callbackOutput = null;
									try {
										callbackOutput = (callback || defaultCallback)();
									} catch (e) {
										return makePromise(e, false);
									}
									if (callbackOutput && isFunction(callbackOutput.then)) {
										return callbackOutput.then(function () {
											return makePromise(value, isResolved);
										}, function (error) {
											return makePromise(error, false);
										});
									} else {
										return makePromise(value, isResolved);
									}
								}

								return this.then(function (value) {
									return handleCallback(value, true);
								}, function (error) {
									return handleCallback(error, false);
								});
							}
						}
					};

					return deferred;
				};

				var ref = function ref(value) {
					if (value && isFunction(value.then)) return value;
					return {
						then: function then(callback) {
							var result = defer();
							result.resolve(callback(value));
							return result.promise;
						}
					};
				};

				/**
     * @param {*} reason Constant, message, exception or an object representing the rejection reason.
     * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
     */
				var reject = function reject(reason) {
					var result = defer();
					result.reject(reason);
					return result.promise;
				};

				var createInternalRejectedPromise = function createInternalRejectedPromise(reason) {
					return {
						then: function then(callback, errback) {
							var result = defer();
							try {
								result.resolve((isFunction(errback) ? errback : defaultErrback)(reason));
							} catch (e) {
								result.reject(e);
								exceptionHandler(e);
							}
							return result.promise;
						}
					};
				};

				/**
     * @param {*} value Value or a promise
     * @returns {Promise} Returns a promise of the passed value or promise
     */
				var when = function when(value, callback, errback, progressback) {
					var result = defer(),
					    done;

					var wrappedCallback = function wrappedCallback(value) {
						try {
							return (isFunction(callback) ? callback : defaultCallback)(value);
						} catch (e) {
							exceptionHandler(e);
							return reject(e);
						}
					};

					var wrappedErrback = function wrappedErrback(reason) {
						try {
							return (isFunction(errback) ? errback : defaultErrback)(reason);
						} catch (e) {
							exceptionHandler(e);
							return reject(e);
						}
					};

					var wrappedProgressback = function wrappedProgressback(progress) {
						try {
							return (isFunction(progressback) ? progressback : defaultCallback)(progress);
						} catch (e) {
							exceptionHandler(e);
						}
					};

					ref(value).then(function (value) {
						if (done) return;
						done = true;
						result.resolve(ref(value).then(wrappedCallback, wrappedErrback, wrappedProgressback));
					}, function (reason) {
						if (done) return;
						done = true;
						result.resolve(wrappedErrback(reason));
					}, function (progress) {
						if (done) return;
						result.notify(wrappedProgressback(progress));
					});

					return result.promise;
				};

				function defaultCallback(value) {
					return value;
				}

				function defaultErrback(reason) {
					return reject(reason);
				}

				/**
     * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
     * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
     *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
     *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
     *   with the same rejection value.
     */
				function all(promises) {
					var deferred = defer(),
					    counter = 0,
					    results = isArray(promises) ? [] : {};

					promises.forEach(function (promise, key) {
						counter++;
						ref(promise).then(function (value) {
							if (results.hasOwnProperty(key)) return;
							results[key] = value;
							if (! --counter) deferred.resolve(results);
						}, function (reason) {
							if (results.hasOwnProperty(key)) return;
							deferred.reject(reason);
						});
					});

					if (counter === 0) {
						deferred.resolve(results);
					}

					return deferred.promise;
				}

				return {
					version: "0.1.0",
					defer: defer,
					reject: reject,
					when: when,
					all: all
				};
			}

			var isFunction = function isFunction(value) {
				return typeof value === 'function';
			},
			    isArray = Array.isArray;

			Q = qFactory(console.log);

			if (window.KISSY && KISSY.add) {
				KISSY.add('q/index', function () {
					return Q;
				});
			}

			exports.default = Q;

			/***/
		}
		/******/])
	);
});
;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./components/q/build/index.js
 ** module id = 5
 ** module chunks = 0
 **/